<template>
  <v-btn
    class="small-fab"
    v-if="icon != null"
    :color="content ? 'primary' : 'white'"
    fab
    elevation="1"
    x-small
    dark
    @click="clicked"
  >
    <v-icon :color="content ? 'white' : 'primary'">{{icon}}</v-icon>
  </v-btn>
  <v-btn
    class="small-fab"
    v-else
    :color="content ? 'primary' : 'white'"
    fab
    elevation="1"
    x-small
    @click="clicked"
  >{{text}}</v-btn>
</template>

<script>
export default {
  name: "IconToggle",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    content: Boolean,
    icon: { type: String, default: null },
    text: String
  },
  data() {
    return {
      menu: false,
      required: false
    };
  },
  computed: {},
  methods: {
    clicked() {
      this.$emit("input", !this.content);
    },
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.small-fab {
  transform: scale(0.8);
  transform-origin: bottom;
}
</style>
